var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint react/jsx-closing-tag-location: 0 */
import React from 'react';
import StyledIcon from './StyledIcon';

var CheckmarkIcon = function CheckmarkIcon(props) {
  return React.createElement(
    StyledIcon,
    _extends({}, props, { xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink', viewBox: '0 0 10 8' }),
    React.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1' },
      React.createElement(
        'g',
        { transform: 'translate(-777.000000, -265.000000)' },
        React.createElement(
          'g',
          { transform: 'translate(770.000000, 208.000000)' },
          React.createElement('path', { d: 'M16.8863801,58.1255789 L15.8410186,57.105781 C15.6938161,56.9628889 15.4576944,56.964393 15.3142281,57.1125495 L10.736755,61.8242266 L8.60344039,59.8019282 C8.52946555,59.7334904 8.43531577,59.6943831 8.33145211,59.7003996 C8.23132456,59.704912 8.13642755,59.7492837 8.0691777,59.8252421 L7.09554933,60.914982 C6.95955519,61.0668988 6.97001628,61.3015425 7.11871317,61.4406743 L10.1569119,64.2917465 C10.1696146,64.3037795 10.1823174,64.3143084 10.1965146,64.3240853 L10.5454666,64.66477 C10.617947,64.7354639 10.7113495,64.7708109 10.8054993,64.7708109 C10.902638,64.7708109 10.9997767,64.7324557 11.0730043,64.6580014 L16.8938523,58.6587918 C16.9633438,58.5865937 17.0014521,58.4903296 16.9999576,58.3910573 C16.9984632,58.2910328 16.9573661,58.1955208 16.8863801,58.1255789' })
        )
      )
    )
  );
};
export default CheckmarkIcon;